import { HTTPService } from 'fides-angularjs-components/src/fts-services/fts-http-service';
import { USER_ACC_REPORTS } from './arsweb/RoutingPaths';

export class BackendService {
    constructor(userService, rootUrl) {
        this.service = new HTTPService(userService.fsMainDependencies);
        this.rootUrl = rootUrl ? rootUrl : "";
    }

    getUserData(restUrl) {
        return this.service.useGetHandler(this.rootUrl + restUrl);
    }

    postUserData(restUrl, requestBody) {
        return this.service.post(this.rootUrl + restUrl, requestBody);
    }

    getUserReport(restUrl) {
        return this.service.useGetHandler(USER_ACC_REPORTS + restUrl);
    }

    postUserReport(restUrl, requestBody) {
        return this.service.post(USER_ACC_REPORTS + restUrl, requestBody);
    }

    getBinaryUserReport(restUrl) {
        return this.service.useBinaryGetHandler(USER_ACC_REPORTS + restUrl);
    }

    postBinaryUserReport(restUrl, requestBody) {
        return this.service.useBinaryPostHandler(USER_ACC_REPORTS + restUrl, requestBody);
    }

    putUserData(restUrl, requestBody) {
        return this.service.put(this.rootUrl + restUrl, requestBody);
    }

    resetPaging(pageSize) {
        this.service.config.params.page = 0;
        this.service.config.params.size = pageSize;
    }
}
